<template>
  <div id="app">
    <H5Robot :cityname="cityname"
             :gid="gid" />
  </div>
</template>

<script>
import H5Robot from "./components/new-robot.vue";
import util from "./util/util.js";

export default {
  name: "app",
  components: {
    H5Robot,
  },
  data() {
    return {
      cityname: "",
      gid: "",
    };
  },
  created() {
    let citycode;
    let isTest;
    let userid;
    let member_userid;
    let appid;
    let platform;
    let channel = this.getUrlParamsValue(window.location.href, "channel");

    if (window.location.href.includes("?")) {
      let query = window.location.href.split("?")[1];
      const queryMap = new Map();
      query.split("&").map((i) => {
        queryMap.set(i.split("=")[0], i.split("=")[1]);
      });
      citycode = queryMap.get("citycode") || "sz";
      this.gid = queryMap.get("gid") || "";
      isTest = queryMap.get("is_test") || "";
      userid = queryMap.get("userid") || "";
      member_userid = queryMap.get("member_userid") || "";
      appid = queryMap.get("appid") || "";
      platform = queryMap.get("platform") || "";
      //存到缓存
      localStorage.setItem("citycode", citycode);
      localStorage.setItem("userid", userid);
      localStorage.setItem("member_userid", member_userid);
      localStorage.setItem("appid", appid);

      console.log(channel);
      if (channel) localStorage.setItem("channel", channel);
      else localStorage.removeItem("channel");

      //防止进来的时候，保留上次的缓存，导致平台错乱和模拟机器人信息记录错乱
      if (platform) localStorage.setItem("platform", platform);
      else localStorage.removeItem("platform");

      if (isTest) localStorage.setItem("isTest", isTest);
      else localStorage.removeItem("isTest");
    }
    this.getQuestion();
    this.queryCityName(citycode);
  },
  mounted() {},
  methods: {
    async queryCityName(citycode) {
      let data = {
        action: "get_cityname",
        citycode: citycode,
      };
      let res = await util.request(data);
      this.cityname = res.data.data.cityname;
      this.$store.commit("changeCityname", this.cityname);
    },

    getQuestion() {
      let question = this.getUrlParamsValue(window.location.href, "question");
      console.log(question);
      if (question) localStorage.setItem("question", question);
      else localStorage.removeItem("question");
    },

    getUrlParamsValue(url, key) {
      let strParams = url.split("?")[1];
      //如果没有query参数，strParams是undefined，直接返回null
      if (!strParams) return null;
      let urlParams = new URLSearchParams(strParams);
      if (key) {
        return urlParams.get(key);
      } else {
        let obj = {};
        //遍历URLSearchParams对象，获取全部键值对
        urlParams.forEach((value, key) => {
          obj[key] = value;
        });
        return obj;
      }
    },
  },
};
</script>

<style>
</style>
